import type { TiersProduct } from '@weft/services';
import { isSingleVariantProduct } from '@weft/services';
import type { PriceTier, TiersProductVariant } from '@weft/types';
import React from 'react';
import { useChargeContext } from '../../../charge-context';
import { PlanChargesContainer } from '../../../PlanChargesContainer';
import { UsageProductVariantHeaderView } from '../UsageProductVariantHeaderView';
import { UsageProductVariantSummary } from '../UsageProductVariantSummary';
import { UsageProductVariantTable } from '../UsageProductVariantTable';

export const TieredSubscriptionUsageCharge: React.FC = () => {
  const { item: product, itemIndex: productIndex, currency } = useChargeContext<TiersProduct>();

  return (
    <div className="flex flex-col gap-y-4">
      <PlanChargesContainer
        key={product.id}
        className="px-0 pb-0 pt-4"
      >
        <div>
          {!isSingleVariantProduct(product) && (
            <UsageProductVariantHeaderView
              name={product.name}
              className="px-8"
              isProductTitle
            />
          )}
          <div className="space-y-8">
            {product.variants.map((variant, variantIndex) => (
              <div
                key={variant.id}
              >
                <UsageProductVariantHeaderView
                  name={variant.name}
                  description={variant.description ?? undefined}
                  className="px-8"
                />
                <UsageProductVariantTable
                  key={variant.id}
                  isEditing={false}
                  tiers={getTiers(variant)}
                  productIndex={productIndex}
                  isFlatRate
                  isTieredSubscriptionProduct
                  productVariantIndex={variantIndex}
                  currency={currency}
                />
              </div>
            ))}
          </div>
          <UsageProductVariantSummary {...{ product, isEditing: false, productIndex, editable: false, enterEditMode: () => {}, currency }} />
        </div>
      </PlanChargesContainer>
    </div>
  );
};

function getTiers(productVariant: TiersProductVariant): Partial<PriceTier>[] {
  const tiers = productVariant.pricing?.priceConfiguration?.tiers as Partial<PriceTier>[];

  return tiers ?? [] as Partial<PriceTier>[];
}